import { Alert } from 'reactstrap';
import { FC, PropsWithChildren } from 'react';
import Tooltip from 'common/components/general/Tooltip';
import useTooltipID from 'common/utils/hooks/useTooltipID';

type CellWarningTooltipProps = PropsWithChildren<{
  warning: string;
  color?: string;
  textColor?: string;
  tooltipInnerClassName?: string;
}>;

const CellWarningTooltip: FC<CellWarningTooltipProps> = ({
  children,
  warning,
  color = 'red',
  textColor = 'red',
  tooltipInnerClassName
}) => {
  const { tooltipID, avoidRender } = useTooltipID('cell-warning');

  return (
    <Alert
      id={tooltipID}
      color={color}
      className={`rounded rounded-sm cps-4 cpe-4 cpt-2 cpb-2 mb-0 mt-0 w-100p text-${textColor} fw-bold`}
    >
      {children}

      {avoidRender ? null : (
        <Tooltip
          innerClassName={tooltipInnerClassName || 'text-start'}
          fade={false}
          target={tooltipID}
        >
          <span dangerouslySetInnerHTML={{ __html: warning }}></span>
        </Tooltip>
      )}
    </Alert>
  );
};

export default CellWarningTooltip;
